<template>
  <div class="affairs">
    <headd></headd>
    <div class="kv">
      <img :src="fwbanner.pagevaluepc" class="hidden-xs" />
      <img :src="fwbanner.pagevalue" class="hidden-lg hidden-md hidden-sm" />
    </div>
    <div class="container">
      <div class="re_title">企业法律顾问服务</div>
      <div class="re_input">
        <div class="icon">￥</div>
        {{ price }}
      </div>
      <div class="info">
        <div class="name">请选择支付方式</div>
        <div class="pay_type">
          <div
            class="type_item"
            v-for="(item, index) in items"
            :key="item.value"
          >
            <div class="type_name">
              <div class="type_icon">
                <img :src="'../../static/order/pay_' + item.value + '.png'" />
              </div>
              {{ item.name }}
            </div>
            <div>
              <input
                class="radio"
                type="radio"
                id="type"
                :value="item.value"
                :checked="index === current"
                v-model="paytype"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="btn_pay" @click="payorder">立即购买</div>
    </div>
    <!-- <uni-popup ref="popup" type="center">
			<div class="xieyi">
				<rich-text type="text" :nodes="protocol"></rich-text>
				<div class="btnd_list">
					<div class="btnx_c" @click="cancle">取消</div>
					<div class="btnx" @click="comfir">确认</div>
				</div>
				
			</div>
		</uni-popup>	 -->
    <el-dialog :visible.sync="dialogFormVisible_2" width="7rem">
      <div class="xieyi">
        <!-- <rich-text type="text" :nodes="protocol"></rich-text> -->
        <div v-html="protocol"></div>
        <div class="btnd_list">
          <div class="btnx_c" @click="cancle">取消</div>
          <div class="btnx" @click="comfir">确认</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogFormVisible"
      width="6rem"
      :before-close="handleClose"
    >
      <div class="code_con">
        <div class="qr_tip">
          <span>使用微信扫码支付</span>
        </div>
        <div id="qrCode" ref="qrCodeDiv"></div>
        <div class="qr_btn" @click="qr_btn">完成</div>
      </div>
    </el-dialog>
    <foot></foot>
  </div>
</template>

<script>
import { getbuyfwzxpage, getfwzxpayment } from "./api/api"; //引入api里面定义的方法
import headd from "../components/head";
import foot from "@/components/foot";
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      isread: false,
      fwbanner: "",
      price: "",
      protocol: "",
      items: [
        {
          value: "1",
          name: "支付宝"
        },
        {
          value: "2",
          name: "微信"
        }
      ],
      type: ["alipay", "wxpcpay"],
      current: 0,
      info: {
        recharge_price: 0
      },
      isChange: -1,
      paytype: "1",
      dialogFormVisible: false,
      mobile: false,
      dialogFormVisible_2: false
    };
  },
  metaInfo: {
    title: "马上创业网 专注企业注册的网站", // set a title
    meta: [
      {
        // set meta
        name: "keyWords",
        content:
          "马上创业网，注册公司，代理记账，上海注册公司，注册公司流程，注册公司费用，商标注册，法务咨询，法律服务，个体工商户注册，许可证办理，专业法律，社保，公积金，专利申请，医疗器械许可证，ICP电信增值许可证，食品经营许可证，酒类经营许可证，餐饮服务许可证，道路运输许可证，广播电视节目许可证，海关资质，进出口许可证，商标设计，logo设计，VI设计，海报设计，包装设计，APP开发，微信运营，网站定制，版权服务，软件著作权，发明专利，外观设计专利，实用新型专利，商标转让，驳回复审，注销公司，股权变更，经营范围变更，股权协议，股权转让，劳务派遣"
      },
      {
        name: "description",
        content:
          "马上创业网是一个专为中小企业服务的综合平台，主要提供医疗器械服务、审计服务、知识产权服务、财税咨询、注册公司、代理记账、商标注册、专利申请、社保代理、法务代理等一站式的服务，借助移动互联网技术，改善并升级企业服务状态，实现了新形势下中小企业所需要的企业服务。"
      }
    ]
  },
  components: {
    headd,
    foot
  },
  mounted() {
    this.buyfwzxPageData();
    if (this.isWeiXin()) {
      this.items = [
        {
          value: "2",
          name: "微信"
        }
      ];
      this.paytype = "2";
      this.mobile = true;
    } else {
      this.items = [
        {
          value: "1",
          name: "支付宝"
        },
        {
          value: "2",
          name: "微信"
        }
      ];
      this.paytype = "1";
      this.mobile = false;
    }
  },
  methods: {
    //判断是否是微信浏览器的函数
    isWeiXin() {
      //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
      var ua = window.navigator.userAgent.toLowerCase();
      //alert(JSON.stringify(ua));
      //通过正则表达式匹配ua中是否含有MicroMessenger字符串
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    },
    handleClose() {
      console.log(123);
      this.dialogFormVisible = false;
      document.getElementById("qrCode").innerHTML = "";
    },
    qr_btn() {
      console.log(123);
      this.dialogFormVisible = false;
      document.getElementById("qrCode").innerHTML = "";
    },
    cancle() {
      this.isread = false;
      this.dialogFormVisible_2 = false;
    },
    comfir() {
      this.isread = true;
      this.dialogFormVisible_2 = false;
      this.payorder();
    },
    async buyfwzxPageData() {
      var _self = this;
      const res = await getbuyfwzxpage();
      var data = res.data.data;
      //console.log(data)
      _self.fwbanner = data.fwbanner;
      _self.protocol = data.protocol;
      _self.price = data.price;
    },
    radioChange: function(evt) {
      for (let i = 0; i < this.items.length; i++) {
        if (this.items[i].value === evt.target.value) {
          console.log(i);
          this.current = i;
          break;
        }
      }
    },
    gorecharge(e) {
      var that = this;
      that.recharge_price = e.detail.value;
    },

    payorder() {
      var _self = this;
      if (!_self.isread) {
        this.dialogFormVisible_2 = true;
        return false;
      }
      if (_self.type[_self.paytype - 1] == "alipay") {
        var parm = [
          {
            name: "uid",
            value: localStorage.getItem("userId")
          },

          {
            name: "pay_type",
            value: "alipay"
          },
          {
            name: "sessionToken",
            value: localStorage.getItem("sessionToken")
          }
        ];
        //模拟form表单
        var temp_form = document.createElement("form");
        temp_form.action =
          "https://mscyeserver.mscye.com/webstf.php/webStfapi/fwzxpayment";
        //如需打开新窗口，form的target属性要设置为'_blank'
        temp_form.target = "_self";
        temp_form.method = "post";
        temp_form.style.display = "none";
        //添加参数
        for (var item in parm) {
          var opt = document.createElement("textarea");
          //console.log(parm[item].name);
          opt.name = parm[item].name;
          opt.value = parm[item].value;
          temp_form.appendChild(opt);
        }
        document.body.appendChild(temp_form);
        //提交数据
        temp_form.submit();
      } else if (_self.type[_self.paytype - 1] == "wxpcpay") {
        // var parm = {
        //   uid: localStorage.getItem("userId"),
        //   pay_type: "wxpcpay"
        // };
        // _self.pay_weixin(parm);

        if (_self.mobile) {
          var parm = {
            uid: localStorage.getItem("userId"),
            openid: localStorage.getItem("openid"),
            pay_type: "wxjspay"
          };
          _self.pay_weixin_mobile(parm);
        } else {
          var parm = {
            uid: localStorage.getItem("userId"),
            pay_type: "wxpcpay"
          };
          _self.pay_weixin(parm);
        }
      }
    },
    async pay_weixin(parm) {
      var _self = this;
      const res = await getfwzxpayment(parm);
      console.log(JSON.parse(res.data.payStr).code_url);
      _self.dialogFormVisible = true;
      _self.$nextTick(function() {
        var qrcode = new QRCode(this.$refs.qrCodeDiv, {
          text: JSON.parse(res.data.payStr).code_url,
          width: 200,
          height: 200,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.H
        });
      });
    },
    async pay_weixin_mobile(parm) {
      var _self = this;
      const res = await getfwzxpayment(parm);
      var data = JSON.parse(res.data.payStr);
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener(
            "WeixinJSBridgeReady",
            onBridgeReady,
            false
          );
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
          document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
        }
      } else {
        _self.onBridgeReady(data);
      }
    },
    onBridgeReady(data) {
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: "" + data.appId,
          timeStamp: "" + data.timeStamp,
          nonceStr: "" + data.nonceStr,
          package: "" + data.package,
          signType: "" + data.signType,
          paySign: "" + data.paySign
        },
        function(res) {
          console.log(res);
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            this.$router.push({
              path: "/"
            });
            // 使用以上方式判断前端返回,微信团队郑重提示：
            //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          }
        }
      );
    },
    async pay(parm) {
      console.log(parm);
      var _self = this;
      const res = await this.$myRuquest({
        url: "/fwzxpayment",
        data: parm,
        method: "POST"
      });
      console.log(res);

      if (res.data.status == 1) {
        console.log(_self.type[_self.current]);
        if (_self.type[_self.current] == "alipay") {
          console.log("alipay");
          uni.requestPayment({
            provider: "alipay", //服务提供商（支付宝）（服务提供商，通过uni.getProvider获取）
            orderInfo: res.data.data.payStr, //后台返回的支付宝订单数据
            success(res) {
              console.log("success:" + JSON.stringify(res));
              return uni.showToast({
                title: "支付成功",
                complete: function(res) {
                  uni.switchTab({
                    url: "/pages/index/index"
                  });
                }
              });
            },
            fail(err) {
              uni.showModal({
                title: "支付失败"
              });
              console.log("fail:" + JSON.stringify(err));
            }
          });
        } else if (_self.type[_self.current] == "wxpay") {
          console.log("wxpay");
          //console.log(ordernfo)
          uni.requestPayment({
            provider: "wxpay", //服务提供商（微信）（服务提供商，通过uni.getProvider获取）
            orderInfo: JSON.parse(res.data.data.payStr), //后台返回的微信订单数据
            success(res) {
              console.log("success:" + JSON.stringify(res));
              return uni.showToast({
                title: "支付成功",
                complete: function(res) {
                  uni.switchTab({
                    url: "/pages/index/index"
                  });
                }
              });
            },
            fail(err) {
              uni.showModal({
                title: "支付失败"
              });
              console.log("fail:" + JSON.stringify(err));
            }
          });
        }
      }
    }
  }
};
</script>

<style lang="less">
.affairs {
  padding: 0 0 0.3rem 0;
  flex-direction: column;
  width: 100%;
  @media (max-width: 991px) {
    width: 6.86rem;
    margin: 0.3rem auto;
  }
  .kv {
    width: 100%;
    margin-bottom: 0.32rem;
    img {
      width: 100%;
    }
  }

  .re_title {
    font-size: 0.24rem;
    color: #8d8e99;
    padding: 0 0.32rem;
    margin-bottom: 0.1rem;
    @media (max-width: 991px) {
      font-size: 0.32rem;
    }
  }

  .re_input {
    border-bottom: 0.01rem solid #ccc;
    align-items: center;
    padding: 0.23rem 0.32rem;
    font-size: 0.5rem;
    line-height: 0.5rem;
    color: #ff545a;
    display: flex;
    justify-content: center;
    .icon {
      font-size: 0.3rem;
      margin-right: 0.1rem;
    }
  }

  .info {
    flex-direction: column;
    width: ~"calc(100% - 64rpx)";
    padding: 0.3rem 0.32rem;
    // border-bottom: 1rpx solid rgba(196, 196, 204, 0.5);

    .name {
      font-size: 0.26rem;
      color: #1b1c33;
      line-height: 0.42rem;
      margin-bottom: 0.24rem;
      margin-top: 0.2rem;
      @media (max-width: 991px) {
        font-size: 0.32rem;
      }
    }

    .option {
      flex-direction: row;
      margin-bottom: 20rpx;

      .title {
        font-size: 26rpx;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #1b1c33;
        line-height: 37rpx;
        width: 130rpx;
      }

      .content {
        width: 500rpx;
        flex-direction: column;
        font-size: 26rpx;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #444649;
        line-height: 37rpx;

        view {
          margin-bottom: 15rpx;
          flex-direction: row;

          &:last-child {
            margin-bottom: 0;
          }

          .red {
            color: rgba(255, 84, 90, 1);
          }

          .status {
            margin-left: 32rpx;
            font-weight: 600;
            color: #1395ff;
          }
        }
      }

      &:last-child {
        margin-bottom: 0;
      }
    }

    .price {
      margin-top: 21rpx;
      font-size: 30rpx;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #1b1c33;
      line-height: 42rpx;
      letter-spacing: 1rpx;

      .span {
        color: #ff545a;
      }
    }

    .pay_type {
      width: 4rem;
      margin: auto;

      radio-group {
        width: 100%;
      }

      .type_item {
        justify-content: space-between;
        width: 100%;
        align-items: center;
        margin-bottom: 0.4rem;
        display: flex;

        .type_name {
          font-size: 0.24rem;

          color: #1b1c33;
          display: flex;

          .type_icon {
            width: 0.36rem;
            height: 0.36rem;
            margin-right: 0.2rem;

            img {
              width: 100%;
              height: 100%;
            }
          }
          @media (max-width: 991px) {
            font-size: 0.28rem;
          }
        }
        .radio {
          width: 0.2rem;
          height: 0.2rem;
          @media (max-width: 991px) {
            width: 0.28rem;
            height: 0.28rem;
          }
        }
      }
    }

    .btn_list {
      width: 100%;
      justify-content: space-between;
      margin-top: 20rpx;

      .btn {
        width: 4.94rem;
        height: 0.7rem;
        font-size: 0.24rem;
        color: #ffffff;
        line-height: 0.7rem;
        text-align: center;
        justify-content: center;
        align-items: center;
        @media (max-width: 991px) {
          font-size: 0.28rem;
        }
      }

      .btn.kefu {
        background: url(../../static/order/btn_1.png) no-repeat;
        background-size: 309rpx 80rpx;
      }

      .btn.buy {
        background: #ff545a;
      }
    }
  }

  .btn_pay {
    width: 4.94rem;
    height: 0.7rem;
    font-size: 0.24rem;
    color: #ffffff;
    line-height: 0.7rem;
    text-align: center;
    justify-content: center;
    align-items: center;
    background: #ff545a;
    border-radius: 0.35rem;
    margin: auto;
    cursor: pointer;
    @media (max-width: 991px) {
      font-size: 0.28rem;
    }
  }
}
.xieyi {
  margin: auto;
  background-color: #fff;
  width: 6rem;

  font-size: 0.16rem;
  line-height: 0.25rem;
  @media (max-width: 991px) {
    font-size: 0.26rem;
    line-height: 0.33rem;
  }
  text-align: center;
  padding: 0.32rem 0;
  overflow-y: auto;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .btnd_list {
    justify-content: center;
    display: flex;
    width: 100%;
    .btnx_c {
      margin: 0.3rem 0.2rem;
      width: 1.3rem;
      height: 0.4rem;
      font-size: 0.16rem;
      border-radius: 0.2rem;
      background: #1395ff;
      color: #ffffff;
      line-height: 0.4rem;
      letter-spacing: 0.02rem;
      text-align: center;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      @media (max-width: 991px) {
        height: 0.8rem;
        line-height: 0.8rem;
        font-size: 0.36rem;
        border-radius: 0.4rem;
        width: 2.7rem;
      }
    }
    .btnx {
      margin: 0.3rem 0.2rem;
      width: 1.3rem;
      height: 0.4rem;
      font-size: 0.16rem;
      border-radius: 0.2rem;
      background: #f4556c;
      color: #ffffff;
      line-height: 0.4rem;
      letter-spacing: 0.02rem;
      text-align: center;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      @media (max-width: 991px) {
        height: 0.8rem;
        line-height: 0.8rem;
        font-size: 0.36rem;
        border-radius: 0.4rem;
        width: 2.7rem;
      }
    }
  }
}
.code_con {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .qr_tip {
    font-size: 0.16rem;
    line-height: 0.25rem;
    text-align: center;
    @media (max-width: 991px) {
      font-size: 0.28rem;
      line-height: 0.33rem;
    }
  }
  .qr_btn {
    margin-top: 0.2rem;
    width: 1.26rem;
    height: 0.4rem;
    font-size: 0.24rem;
    line-height: 0.4rem;
    background-color: #1395ff;
    border-radius: 0.2rem;
    color: #ffffff;
    text-align: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    cursor: pointer;
    @media (max-width: 991px) {
      font-size: 0.28rem;
    }
  }
}
@media (max-width: 991px) {
  .head_line {
    border-bottom: 0rem solid #ccc;
    padding-bottom: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/affairs.vue